import { FC } from 'react';

import DentalButton from 'components/Buttons/DentalButton/DentalButton';
import Modal from 'components/Modal/Modal';

import styles from './SlotChangeConfirmationModal.module.scss';

interface SlotChangeConfirmationModalProps {
  open: boolean;

    patientNames: string[];
  isReleasing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const formatPatientNames = (names: string[]) => {
  if (names.length <= 1) return names[0] || '';

  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

const SlotChangeConfirmationModal: FC<SlotChangeConfirmationModalProps> = ({
  open,
  patientNames,
  isReleasing,
  onCancel,
  onConfirm,
}) => {
  const isSinglePatient = patientNames.length === 1;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      isCloseIconDisplayed={false}
      isNotFullScreen
      customStyle={styles['modal']}
    >
      <div className={styles['container']}>
        <h3 className={styles['title']}>Change this appointment time?</h3>
        <span className={styles['info']}>
          {`Appointments are booked in order, so changing this time will clear the time selected for ${formatPatientNames(
            patientNames
          )}. You will need to pick ${
            isSinglePatient ? 'a new time' : 'new times'
          } for ${isSinglePatient ? 'them' : 'each of them'}.`}
        </span>

        <div className={styles['btn-group']}>
          <DentalButton
            variant="outlined"
            className={styles['btn']}
            disabled={isReleasing}
            onClick={onCancel}
          >
            Cancel
          </DentalButton>

          <DentalButton
            variant="contained"
            className={styles['btn']}
            isLoading={isReleasing}
            onClick={onConfirm}
          >
            Yes, change it
          </DentalButton>
        </div>
      </div>
    </Modal>
  );
};

export default SlotChangeConfirmationModal;
